import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { IAfterGuiAttachedParams } from 'ag-grid-community';


@Component({
  selector: 'mydocma-mm-checkbox-renderer',
  template: `
    <input
      type="checkbox"
      (click)="false"
      [checked]="params.value"
      readonly
    />
`,
})
export class CheckboxCellRenderer implements ICellRendererAngularComp, OnDestroy {

  params: any;

  ngOnDestroy(): void {
  }

  refresh(params: any): boolean {
    this.params = params;
    return true;
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
  }

  agInit(params: any): void {
    this.params = params;
  }

  checkedHandler(event) {
      const checked = event.target.checked;
      const colId = this.params.column.colId;
      this.params.node.setDataValue(colId, checked);
  }
}
